const runtimeEnv = window.__ENV__ || {};

export const API_RCV_URL =
  runtimeEnv.API_RCV_URL ||
  import.meta.env.VITE_API_RCV_URL ||
  'http://localhost:8080/api/v1';

export const API_BASE_URL =
  runtimeEnv.API_BASE_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  'http://localhost:8080/api/v1';

export const API_TIMEOUT =
  runtimeEnv.API_TIMEOUT ||
  import.meta.env.VITE_API_TIMEOUT ||
  'http://localhost:8080/api/v1';
